const areAllOptionsSet = (
  product,
  selectedOptions,
  selectedCustomOptions,
  selectedBundleOptions
) => {
  const customOptions = product.custom_options ?? product.customOptions;

  let allOptionsAreSet = true;
  if (product.options) {
    allOptionsAreSet = product.options.every(
      (option) => selectedOptions[option.id]
    );
  }

  if (customOptions) {
    allOptionsAreSet =
      allOptionsAreSet &&
      customOptions.every(
        (option) =>
          selectedCustomOptions[option.option_id] || !option.is_required
      );
  }

  if (product.bundleOptions) {
    allOptionsAreSet =
      allOptionsAreSet &&
      product.bundleOptions.every((option) => {
        return (
          !option.required ||
          (selectedBundleOptions[option.id]?.values.length > 0 &&
            selectedBundleOptions[option.id]?.values[0])
        );
      });
  }

  return allOptionsAreSet;
};

export { areAllOptionsSet };
